import { styled } from '@mui/material/styles';
import {
    Typography,
    Card,
    TableCell,
    AppBar,
    TableRow,
} from '@mui/material';

// Styled Components
export const ContentContainer = styled('div')({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    minHeight: 'calc(100vh - 160px)',
    padding: '20px',
    backgroundColor: '#f0f0f0',
    overflowY: 'auto',
});

export const AdvancedCard = styled(Card)({
    width: '80%',
    backgroundColor: '#ffffff',
    borderRadius: '5px',
    padding: '30px',
    marginBottom: '70px',
    boxShadow: '0px 8px 15px rgba(0, 0, 0, 0.15)',
    backgroundImage: 'linear-gradient(#fff, #fff), linear-gradient(45deg, #1E90FF, #63A4FF)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
});

export const AdvancedTableCColumn = styled(TableCell)(({ theme }) => ({
    fontSize: '1rem',
    padding: '18px',
    backgroundColor: '#f2f6fc',
    color: '#333333',
    fontWeight: 'bold',
    borderBottom: '1px solid #dddddd',
    transition: 'all 0.3s ease-in-out',
    borderBottom: '2px solid #63A4FF',
    '&:hover': {
        backgroundColor: '#e0ecf9',
        color: '#222',
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
    },
}));

export const AdvancedTableCell = styled(TableCell)(({ theme }) => ({
    fontSize: '1rem',
    padding: '18px',
    backgroundColor: '#f9f9f9',
    color: '#333333',
    borderBottom: '1px solid #dddddd',
    transition: 'all 0.3s ease-in-out',
}));

export const AdvancedTableRow = styled(TableRow)({
    '&:nth-of-type(odd)': {
        backgroundColor: '#f3f3f3',
    },
    '&:hover': {
        backgroundColor: '#e9e9e9',
    },
});

// Header Styling
export const HeaderContainer = styled(AppBar)({
    backgroundColor: '#FFFFFF',
    padding: '10px 20px',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
    borderBottom: '2px solid #1E90FF',
});

export const HeaderTitle = styled(Typography)({
    flexGrow: 1,
    fontSize: '1.5rem',
    color: '#333',
    fontWeight: 'bold',
    textAlign: 'center',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
});

export const FooterContainer = styled('footer')({
    backgroundColor: '#1E90FF',
    color: '#ffffff',
    textAlign: 'center',
    padding: '10px 0',
    position: 'relative',
    bottom: 0,
    width: '100%',
});